<template>
  <v-app style="background-color: rgb(242, 242, 242)">
    <portal-target name="destination">
      <!--For loading  -->
    </portal-target>
    <div class="snackbarClass">
      <v-snackbar
        v-for="(snackbar, index) in errors"
        :key="'S' + index"
        :timeout="2000"
        :value="snackbar.value"
        absolute
        top
        :color="snackbar.color"
        :elevation="1"
        right
        tile
      >
        {{ snackbar.name }}
      </v-snackbar>
    </div>

    <v-app-bar
      loading
      app
      dense
      color="success"
      dark
      clipped-left
      clipped-right
    >
      <!-- <v-progress-linear
        class="ma-0 pa-0"
        top
        absolute
        color="#1d2f69"
        height="5"
        value="0"
        :background-opacity="0.1"
        :active="$communicator.waiting_for_response"
        :indeterminate="$communicator.waiting_for_response"
      ></v-progress-linear> -->
      <v-app-bar-nav-icon
        v-on:click.stop="
          detectMob
            ? (navigation = !navigation)
            : (mini_variant = !mini_variant)
        "
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="font-weight-bold"><Logo /></v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark text v-bind="attrs" v-on="on" class="font-weight-bold">
            O Нас
          </v-btn>
        </template>
        <span>
          <table>
            <tr>
              Версия: 1.1.9.7
            </tr>
            <tr>
              Производитель: ООО ООО «INVAN SOFT», Республика Узбекистан
            </tr>
            <tr>
              Программное обеспечение виртуальной кассы «INVAN POS»
            </tr>
          </table>
        </span>
      </v-tooltip>
      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <p v-bind="attrs" v-on="on" color="white" text class="mt-4 mr-4">
            <country-flag :country="lowerLang" size="normal" />
          </p>
        </template>
        <v-list>
          <v-list-item v-for="(item, i) in langs" :key="i">
            <v-list-item-title
              style="cursor: pointer"
              @click="setAppLang(item)"
            >
              {{ item.text }}
              <country-flag :country="flags[i]" size="small" />
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-toolbar-title class="font-weight-bold">{{
        organization
      }}</v-toolbar-title>
      <v-menu
        min-width="300"
        max-width="300"
        offset-y
        v-bind:close-on-content-click="false"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-card tile>
          <v-list nav>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon large>mdi-account-circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ user.name }}</v-list-item-title>
                <v-list-item-subtitle v-if="user.email">{{
                  user.email
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card-actions>
            <v-spacer />
            <v-btn text v-on:click="logout">{{ $t("logout") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      v-model="navigation"
      app
      clipped
      width="300"
      :mini-variant="mini_variant"
      :mini-variant-width="80"
    >
      <v-list dense class="py-0">
        <template v-for="(nav, nav_index) in navs">
          <template v-if="nav.type == 'group' && nav.show">
            <v-list-group
              v-model="nav_obj[nav_index]"
              no-action
              v-bind:key="nav_index"
              @click="navClicked(nav_index)"
            >
              <template v-slot:activator>
                <v-menu v-model="menu_model" :min-width="250" offset-x>
                  <template v-slot:activator="{ on }">
                    <v-list-item-avatar
                      @click="navClicked(nav_index)"
                      v-on="on"
                    >
                      <v-icon v-bind:color="nav.color">{{ nav.icon }}</v-icon>
                    </v-list-item-avatar>
                  </template>
                  <v-list tile v-if="mini_variant && menu_current == nav_index">
                    <v-list-item
                      v-for="(nn, indd) in nav.items"
                      :key="indd + 'AA'"
                      v-bind:to="nn.link"
                    >
                      <v-list-item-title>{{
                        $t(`${nn.title}`)
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-list-item-content>
                  <v-list-item-title class="content_color">{{
                    $t(`${nav.title}`)
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(item, item_index) in nav.items"
                v-bind:key="'item_' + item_index"
                v-bind:to="item.link"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-if="
                      item.title === 'partition_item' ||
                      item.title === 'partition_valuation' ||
                      item.title === 'purchase_employee' ||
                      item.title === 'promotions_and_discounts'
                    "
                    class="pt-2"
                  >
                    {{ $t(`${item.title}`) }}
                    <v-chip
                      class="mt-n2"
                      color="blue"
                      x-small
                      label
                      text-color="white"
                    >
                      {{ $t("beta") }}
                    </v-chip>
                  </v-list-item-title>
                  <v-list-item-title v-else class="color-list">{{
                    $t(`${item.title}`)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>
          <template v-else-if="nav.show">
            <v-list-item v-bind:key="nav_index" v-bind:to="nav.link">
              <v-list-item-avatar>
                <v-icon v-bind:color="nav.color">{{ nav.icon }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t(`${nav.title}`) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-main style="margin-top: 20px">
      <!-- <v-main class="pa-3 ma-3"> -->
      <slot></slot>
      <!-- </v-main> -->
    </v-main>

    <v-navigation-drawer
      v-if="PurchasePricing"
      v-model="navigationRight"
      right
      app
      :width="navigationRight ? 400 : 0"
      clipped
    >
      <slot name="right-drawer" />
    </v-navigation-drawer>
  </v-app>
</template>
<script>
import Userable from "../../mixins/userable";
import Features from "../../mixins/features";
import Langable from "../../mixins/langable";
import Logo from "../../components/VAnimatedLogo/Logo.vue";
export default {
  name: "v-application",
  components: {
    Logo,
  },
  mixins: [Langable, Userable, Features],
  props: {
    navigationRight: {
      type: Boolean,
      default: false,
    },
    PurchasePricing: {
      type: Boolean,
      default: false,
    },
    containerMargin: {
      type: Number,
    },
  },
  data: () => ({
    flags: ["us", "uz", "ru"],
    navigation: false,
    mini_variant: false,
    menu_model: false,
    nav_obj: [],
    menu_current: -1,
    manu_items: [
      ["Sales Summary", "Sales by item", "Sales by Category"],
      ["Item List", "Categories", "Modifiers"],
      ["Purchase Orders"],
      ["Employee list"],
    ],
    organization: "iNVAN!",
    access: null,
    purchaseMarkCount: 0,
    errors: [],
  }),
  methods: {
    logout() {
      this.$store.commit("signout");
      window.location.href = "/signin";
    },
    getLang() {
      this.$i18n.locale = this.$store.state.lang
        ? this.$store.state.lang?.value
        : "en";
    },
    setAppLang(lang) {
      this.$store.commit("lang", lang);
      this.user.ui_language = lang;
      this.$i18n.locale = this.$store.state.lang?.value;
      this.save_user();
      window.location.reload()
    },
    navClicked(index) {
      this.menu_current = index;
      this.mini_variant = false;
    },
    async getAccess() {
      const get_access = this.$communicator.then(
        this,
        await this.$communicator("get_access")
      );
      if (get_access && get_access.access && get_access.feature) {
        this.access = {
          name: get_access.access?.name,
          reports: get_access.access?.reports,
          report_sale: get_access.access?.report_sale,
          report_accaunt: get_access.access?.report_accaunt,
          // report_abs: get_access.access?.report_abs,
          report_sale_by_item: get_access.access?.report_sale_by_item,
          report_sale_by_category: get_access.access?.report_sale_by_category,
          report_sale_by_supplier: get_access.access?.report_sale_by_supplier,
          report_employee: get_access.access?.report_employee,
          report_sale_by_payment: get_access?.access.report_sale_by_payment,
          report_receipt: get_access.access?.report_receipt,
          report_discount: get_access.access?.report_discount,
          report_debt: get_access.access?.report_debt,
          report_taxes: get_access.access?.report_taxes,
          report_shift: get_access.access?.report_shift,
          material_report: get_access.access?.material_report,

          items: get_access.access?.items,
          item_list: get_access.access?.item_list,
          item_mxik_search: get_access.access?.item_mxik_search,
          item_composite_item: get_access.access?.item_composite_item,
          item_add_from_warehause: get_access.feature?.add_from_warehause
            ? get_access.access?.item_add_from_warehause
            : false,
          item_print_label: get_access.access?.item_print_label,
          item_price_change_history:
            get_access.access?.item_price_change_history,
          item_categories: get_access.access?.item_categories,
          item_modifiers: get_access.access?.item_modifiers,
          item_discount: get_access.access?.item_discount,

          item_mark: get_access.feature.prices
            ? get_access.access?.item_mark
            : false,
          prices: get_access.feature?.prices,
          add_from_warehause: get_access.feature?.add_from_warehause,

          employees: get_access.access?.employees,
          employee_list: get_access.access?.employee_list,
          employee_access_rights: get_access.access?.employee_access_rights,
          employee_time_cards: get_access.access?.employee_time_cards,
          employee_total_worked: get_access.access?.employee_total_worked,

          customers: get_access.access?.customers,

          settings: get_access.access?.settings,
          setting_organization: get_access.access?.setting_organization,
          setting_general: get_access.access?.setting_general,
          setting_nds: get_access.access?.setting_nds,
          setting_payment_types: get_access.access?.setting_payment_types,
          setting_currency: get_access.access?.setting_currency,
          setting_loyalty: get_access.access?.setting_loyalty,
          setting_taxes: get_access.access?.setting_taxes,
          setting_receipt: get_access.access?.setting_receipt,
          // setting_open_tickets: get_access.access.setting_open_tickets,
          // setting_buttons: get_access.access.setting_buttons,
          // setting_options: get_access.access.setting_options,
          setting_stores: get_access.access?.setting_stores,
          setting_pos_devices: get_access.access?.setting_pos_devices,

          edit_profile: get_access.access?.edit_profile,
          item_edit: get_access.access?.item_edit,
          item_mark_edit: get_access.access?.item_mark_edit,
          set_the_taxes: get_access.access?.set_the_taxes,
          manage_pos_devices: get_access.access?.manage_pos_devices,
          can_delete_item: get_access.access?.can_delete_item,
          inventory: get_access.access?.inventory,
          inv_purchase_orders: get_access.access?.inv_purchase_orders,
          inv_purchase_mark: get_access.access?.inv_purchase_mark,
          inv_purchase_orders_cost: get_access.access?.inv_purchase_orders_cost,
          inv_transfer_orders: get_access.access?.inv_transfer_orders,
          inv_stock_adjusment: get_access.access?.inv_stock_adjusment,
          inv_stock_adjusment_cost: get_access.access?.inv_stock_adjusment_cost,
          inv_inventory_counts: get_access.access?.inv_inventory_counts,
          inv_productions: get_access.access?.inv_productions,
          inv_productions_cost: get_access.access?.inv_productions_cost,
          inv_suppliers: get_access.access?.inv_suppliers,
          inv_supplier_transaction: get_access.access?.inv_supplier_transaction,
          inv_supplier_transaction_corrector:
            get_access.access?.inv_supplier_transaction_corrector,
          inv_fees: get_access.access?.inv_fees,
          inv_inventory_history: get_access.access?.inv_inventory_history,
          inv_inventory_valuation: get_access.access?.inv_inventory_valuation,
          inv_supplier_valuation: get_access.access?.inv_supplier_valuation,
          client_debt_by_category: get_access?.feature.client_debt_by_category,
          workgroup_edit_cost: get_access.access?.workgroup_edit_cost,
          workgroup: get_access.access?.workgroup,

          create: get_access.access?.create,
          create_purchase: get_access.access?.create_purchase,
          create_mark: get_access.access?.create_mark,
          create_taxes: get_access.access?.create_taxes,
          create_store: get_access.access?.create_store,
          create_pos_device: get_access.access?.create_pos_device,
          create_customer: get_access.access?.create_customer,
          create_employee: get_access.access?.create_employee,
          create_access: get_access.access?.create_access,
          create_time_card: get_access.access?.create_time_card,
          create_transfer: get_access.access?.create_transfer,
          create_stock_adjustmen: get_access.access?.create_stock_adjustmen,
          create_inv_count: get_access.access?.create_inv_count,
          create_production: get_access.access?.create_production,
          create_supplier: get_access.access?.create_supplier,
          create_supplier_create_doc:
            get_access.access?.create_supplier_create_doc,
          create_fee: get_access.access?.create_fee,
          create_good_sale: get_access.access?.create_good_sale,
          create_good_category: get_access?.access.create_good_category,
          create_modifier: get_access.access?.create_modifier,
          create_discount: get_access.access?.create_discount,
          create_reciept: get_access.access?.create_reciept,
        };
        this.$store.commit("setAccess", this.access);
      }
    },
    async getNotPricedPurchases() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("inv_purchase_count")
      );
      if (result && result.counted) {
        this.purchaseMarkCount = result.counted;
      }
    },
  },
  computed: {
    lowerLang() {
      if (this.$i18n.locale !== "en") {
        return this.$i18n.locale;
      } else {
        return "us";
      }
    },
    navs() {
      let navs = this.$copy(this.$store.state.navs);
      const access = this.access || {};
      const feature = this.feature || {};
      access.is_boss = this.user && this.user.is_boss;
      for (let ind = 0; ind < navs.length; ind++) {
        const hasField = "access" in navs[ind];
        const field = navs[ind]["access"];
        if (!hasField || (hasField && access[field])) {
          navs[ind].show = true;
        } else {
          navs[ind].show = false;
        }
        if (navs[ind].type == "group") {
          const items = [];
          for (let j = 0; j < navs[ind].items.length; j++) {
            const hasField = "access" in navs[ind].items[j];
            const hasFieldf = "feature" in navs[ind].items[j];
            const field = navs[ind].items[j]["access"];
            if ((!hasField && !hasFieldf) || (hasField && access[field])) {
              items.push(navs[ind].items[j]);
            } else {
              const fieldf = navs[ind].items[j]["feature"];
              if (hasFieldf && feature[fieldf]) {
                items.push(navs[ind].items[j]);
              }
            }
          }

          navs[ind].items = items;
        }
      }
      // if (this.access) {
      //   if (this.access.reports) {
      //     navs[0].show = true;
      //   }
      //   if (this.access.items) {
      //     navs[1].show = true;
      //     const items = [];
      //     for (const ind in navs[1].items) {
      //       if (ind == 4 && this.access.item_mark) {
      //         items.push(navs[1].items[ind]);
      //       } else if (ind == 2 && this.access.add_from_warehause) {
      //         items.push(navs[1].items[ind]);
      //       } else if (ind != 4 && ind != 2) {
      //         items.push(navs[1].items[ind]);
      //       }
      //     }
      //     navs[1].items = items;
      //   }
      //   if (this.access.inventory) {
      //     let inventory_show = false;
      //     const items = [];
      //     for (const ind in navs[2].items) {
      //       if (ind == 0 && this.access.inv_purchase_orders) {
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 1 && this.access.inv_purchase_mark) {
      //         navs[2].items[ind].count = this.purchaseMarkCount;
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 2 && this.access.inv_transfer_orders) {
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 3 && this.access.inv_stock_adjusment) {
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 4 && this.access.inv_inventory_counts) {
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 5 && this.access.inv_productions) {
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 6 && this.access.inv_suppliers) {
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 7 && this.access.inv_supplier_transaction) {
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 8 && this.access.inv_fees) {
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 9 && this.access.inv_inventory_history) {
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 10 && this.access.inv_inventory_valuation) {
      //         items.push(navs[2].items[ind]);
      //         inventory_show = true;
      //       } else if (ind == 11) {
      //         items.push(navs[2].items[ind]);
      //       }
      //     }
      //     if (inventory_show) {
      //       navs[2].items = items;
      //     }
      //     navs[2].show = inventory_show;
      //   }
      //   if (this.access.workgroup) {
      //     navs[3].show = true;
      //   }
      //   if (this.access.employees) {
      //     navs[4].show = true;
      //     const items = [];
      //     for (const ind in navs[4].items) {
      //       if (this.access.edit_profile && ind == 0) {
      //         items.push(navs[4].items[ind]);
      //       } else if (!(ind == 0)) {
      //         items.push(navs[4].items[ind]);
      //       }
      //     }
      //     navs[4].items = items;
      //   }
      //   if (this.access.customers) {
      //     navs[5].show = true;
      //   }
      //   if (this.access.settings) {
      //     navs[6].show = true;
      //     const items = [];
      //     for (const ind in navs[6].items) {
      //       if (this.access.set_the_taxes && ind == 6) {
      //         items.push(navs[6].items[ind]);
      //       } else if (this.access.manage_pos_devices && ind == 11) {
      //         items.push(navs[6].items[ind]);
      //       } else if (!(ind == 6 || ind == 11)) {
      //         items.push(navs[6].items[ind]);
      //       }
      //     }
      //     navs[6].items = items;
      //   }
      // } else {
      //   navs = [];
      // }
      return navs;
    },
    detectMob() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
      ];
      return (
        toMatch.some((toMatchItem) => {
          return navigator.userAgent.match(toMatchItem);
        }) || window.innerWidth < 950
      );
    },
  },
  beforeMount() {
    this.getLang();
    this.nav_obj = this.$store.state.nav_obj;
    this.mini_variant = this.$store.state.mini_variant;
    if (this.user == null) {
      window.location.href = "/signin";
    } else {
      this.$communicator.auth(this.user, this.token, this);
    }
    this.access = this.$store.state.access;
  },
  mounted() {
    this.getAccess();
    this.getNotPricedPurchases();
    if (this.user == null) {
      window.location.href = "/signin";
    } else {
      this.$communicator.auth(this.user, this.token, this);
    }
    if (this.detectMob) {
      this.navigation = false;
      this.mini_variant = false;
    } else {
      this.navigation = true;
      this.mini_variant = false;
    }

    window.addEventListener(
      "resize",
      function () {
        if (this.detectMob) {
          this.navigation = false;
          this.mini_variant = false;
        } else {
          this.navigation = true;
          this.mini_variant = false;
        }
      },
      true
    );
    this.nav_obj = this.$store.state.nav_obj;
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.$communicator.auth(this.user, this.token);
      },
    },
    nav_obj: {
      deep: true,
      handler() {
        this.$store.commit("setNavObj", this.nav_obj);
      },
    },
    mini_variant() {
      this.$store.commit("setMiniVariant", this.mini_variant);
      if (this.mini_variant) {
        this.$store.commit("setNavObj", [
          false,
          false,
          false,
          false,
          false,
          false,
        ]);
      }
    },
  },
};
</script>
<style lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.snackbarClass {
  position: fixed;
  top: 50px;
  right: 15px;
  display: flex;
  width: 100vw;
  flex-direction: column-reverse;
  align-items: flex-end;
  justify-content: space-around;
  z-index: 500;
  div {
    position: relative !important;
  }
}
.color-list {
  color: #000000bb;
  font-weight: bold !important;
  font-family: "Montserrat", sans-serif;
}
.content_color {
  color: #000000bb;
  font-weight: bold !important;
  font-family: "Montserrat", sans-serif;
}
</style>
